<template>
  <b-form-group
    :description="description"
    label-for="dsdcLevel"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
  >
    <template v-slot:label>
      <span>{{ label }}</span>
    </template>

    <v-select
      id="level"
      v-model="temp"
      :options="dsdcLevels"
      :reduce="(level) => level.value"
      :clearable="false"
      label="label"
      placeholder="เลือกระดับหลักสูตร"
      @input="update"
    ></v-select>
  </b-form-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'DsdcLevelSelector',
  components: { vSelect },
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    value: { type: String, default: null },
    attribute: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
    company: { default: null, type: Object },
  },
  data() {
    return {
      validFeedback: '',
      invalidFeedback: '',
      temp: this.value,
      dsdcLevels: [
        { value: 'FUNDAMENTAL', label: 'ระดับพื้นฐาน (Fundamental Skills)' },
        { value: 'BASIC', label: 'ระดับต้น (Basic Skills)' },
        { value: 'INTERMEDIATE', label: 'ระดับกลาง (Intermediate Skills)' },
        { value: 'ADVANCED', label: 'ระดับสูง (Advanced Skills)' },
      ],
    };
  },
  computed: {
    ...mapGetters('CourseManagement', [
      'isLoading',
      'courseInfo',
      'courseAttributeUpdated',
    ]),
  },
  methods: {
    ...mapActions('CourseManagement', ['updateDsdcLevel', 'getCourseInfo']),
    update() {
      this.updateDsdcLevel({
        courseId: this.$route.params.courseId,
        dsdcLevel: this.temp,
      }).then(() => {
        this.getCourseInfo({
          courseId: this.$route.params.courseId,
          temp: true,
          excepts: 'numberOfStudent,numberOfActiveStudent',
        });
      });
    },
  },
  watch: {
    value(newVal) {
      this.temp = newVal;
    }
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 5px 4px;
}
.vs__search,
.vs__search:focus {
  border: 0px solid transparent;
}
</style>
